import { render, staticRenderFns } from "./DisplayBookingPosition.vue?vue&type=template&id=988d7654&scoped=true&"
import script from "./DisplayBookingPosition.vue?vue&type=script&lang=js&"
export * from "./DisplayBookingPosition.vue?vue&type=script&lang=js&"
import style0 from "./DisplayBookingPosition.vue?vue&type=style&index=0&id=988d7654&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988d7654",
  null
  
)

export default component.exports